import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setUserById } from './../../actions/setUserById';
import { setLogout } from './../../actions';
import { getUser } from './../../reducers';
import MainMenuAdmin from './../../components/admin/MainMenuAdmin';
import { MenuAdmin, LOGIN } from './../../constants/menu_items';
import { auth } from './../../config/Fire';
import LoadingPage from './../../components/LoadingPage';
import RestaurantsAdmin from './RestaurantsAdmin';
import ConfigurationsGeneralAdmin from './ConfigurationsGeneralAdmin';
import UsersAdmin from './UsersAdmin';
import AnalyticalReservationsPerDayAdmin from './AnalyticalReservationsPerDayAdmin';
import AnalyticalReservationsRangeAdmin from './AnalyticalReservationsRangeAdmin';
import RestaurantsPriorityAdmin from './RestaurantsPriorityAdmin';
import Home from './Home';

const { Header, Content, Footer } = Layout;
const logo = require('./../../images/logo_reservando_word.png');

class HomeAdmin extends Component {
    constructor() {
        super();
        this.state = {
            loading: true,
            itemSelected: MenuAdmin.HOME,
        };
    }

    onItemClick = ({itemClickType}) => {
        switch (itemClickType) {
            case MenuAdmin.HOME:
                this.props.history.push(`/${LOGIN}`);
                break;
            case MenuAdmin.LOGOUT:
                this.props.history.push(`/${LOGIN}`);
                this.props.setLogout();
                auth.signOut();
                break;
            default:
                this.props.history.push(`/${LOGIN}/${itemClickType}`);
                break;
        }
        this.setState({ itemSelected: itemClickType });
    }

    componentDidMount() {
        this.setState({ loading: false });
        /*fire.auth().createUserWithEmailAndPassword("arielrod@gmail.com", "reservando123").then((u)=>{
        }).then((u)=>{
            console.log(u);
        })
        .catch((error) => {
            console.log(error);
        })*/
    }
    

    render() {
        const { location } = this.props;
        return (
            <div className="MainRestoCont">
                {
                    this.state.loading ?
                        <LoadingPage />
                        :
                            <Layout style={{ minHeight: '100vh' }}>
                                {/*<Menu className="HeaderMenuCont" theme="dark" mode="inline" selectable={false}>
                                    <Menu.Item key="0" style={{ textAlign:"center"}} title="Administrador">
                                        { !this.state.collapsed ?
                                            <span>Administrador</span> :
                                            <span></span>
                                        }
                                    </Menu.Item>
                                    </Menu>*/}
                                <MainMenuAdmin onItemClick={this.onItemClick} itemSelected={location.pathname} />
                                <Layout>
                                    <Header style={{ background: '#fff', padding: 0 }} >
                                        <img alt="example" src={logo} style={{ display:"block", margin:"auto", maxHeight:"100%" }} />
                                    </Header>
                                    <Content style={{ margin: '0 8px' }}>
                                            <div style={{ margin: '8px 0', padding: 24, background: '#fff', minHeight: 360 }}>
                                                <Route exact path={`/${LOGIN}/${MenuAdmin.CONFIGURATIONS_GENERAL}`} component={ ConfigurationsGeneralAdmin }/>
                                                <Route exact path={`/${LOGIN}/${MenuAdmin.ANALYTICAL_RESERVATIONS_PER_DAY}`} component={ AnalyticalReservationsPerDayAdmin } />
                                                <Route exact path={`/${LOGIN}/${MenuAdmin.ANALYTICAL_RESERVATIONS_RANGE}`} component={ AnalyticalReservationsRangeAdmin } />
                                                <Route exact path={`/${LOGIN}/${MenuAdmin.RESTAURANTS_ADMIN}`} component={ RestaurantsAdmin }/>
                                                <Route exact path={`/${LOGIN}/${MenuAdmin.RESTAURANTS_PRIORITY_ADMIN}`} component={ RestaurantsPriorityAdmin }/>
                                                <Route exact path={`/${LOGIN}/${MenuAdmin.USERS_ADMIN}`} component={ UsersAdmin }/>
                                                <Route exact path={`/${LOGIN}`} component={ Home } />
                                            </div>
                                    </Content>
                                    <Footer style={{ textAlign: 'center' }}>
                                        Copyright ©2019 Reservando
                                    </Footer>
                                </Layout>
                            </Layout>
                }
            </div>
        );
    };
}

HomeAdmin.propTypes = {
    setUserById: PropTypes.func.isRequired,
    setLogout: PropTypes.func.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setUserById: value => dispatch(setUserById(value)),
    setLogout: value => dispatch(setLogout(value)),
});

const mapStateToProps = state => ({ 
    user:  getUser(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(HomeAdmin));